export default "__VITE_PUBLIC_ASSET__4c64690a__"